import React, { Component } from 'react';
import {connect}            from 'react-redux';
import $                    from 'jquery';
import Dropzone                          from 'react-dropzone';
import {Redirect}                        from 'react-router-dom';
import { SetRespondeTarefasUploadFiles,
        GetTarefasAluno }                from '../../../actions/tarefaAction';
import { SetError }                      from '../../../actions/authenticActions';

class missao_acao extends Component {
    constructor(props){
        super(props)
         this.state = {
                        file : null
                     }
    }   
    
    onDrop(file){
        if(file.length ===0){
            alert('Formato do arquivo não é suportado.');
        }else{
            this.setState({file:file})
            this.setResponderMissao(file);
        }
     }
 
     setResponderMissao(val){
        
        const file = (val?val[0]:null);

         let dados = {
              tar_id                  : this.props.dados.tar_id,
              tar_cod_equipe          : 0,
              tar_flag_entrega_equipe : this.props.dados.tar_flag_entrega_equipe,
              use_id                  : this.props.session.id,
              file                    : file
         }
        
         this.props.SetRespondeTarefasUploadFiles(dados).then((response)=>{
             if (response ===false) {
                alert('Erro no envio! Verifique se o tipo do arquivo é permitido.');
             } else {
                alert('Resposta enviada com sucesso!');
                this.props.GetTarefasAluno(this.props.session.turma);
                this.setState({acao:true});                 
             }           
          }).catch((error) => {
             this.props.SetError(500);
          });
     }


     updateTextoButton(val){
    
         $(`.${val.tar_id}_acao`).addClass('cursor-pointer');
         $(`.${val.tar_id}_acao`).hover(
             function () {
                 $(this).text('Reenviar');
                 $(this).addClass('cursor-pointer');

             }, function () {
                 $(this).text((val.status === 4 ? "Enviado" : "Enviado"));
             }
         );        
    }


    render() {

        if(this.state.Redirect) {
            return (<Redirect to={this.props.menu.missao.home}/>);
         }                  
       
        const status = this.props.dados.tar_status;
        const acaoButton = (this.props.dados.tar_flag_resposta === 1 ? {
            text   : (status ===4  ? "Enviado" :"Enviar"), 
            classe : (status ===4 || status===3 ? `action-acao cursor-pointer ${this.props.dados.tar_id}_acao` :"action cursor-pointer")
           }:
           {
            text   : (status ===4 || status===3 || status===2 ? "Concluído":"Concluir"),
            classe : (status ===4 || status===3 || status===2 ? "action-acao action-acao-state" : "action cursor-pointer"),
            funcao : (status ===4 || status===3 || status===2 ? void(0) :this.setResponderMissao.bind(this,null)),  
        });
      
        return (
            <div>
                {this.props.dados.tar_flag_resposta === 1 ? 
                    <Dropzone
                        className={acaoButton.classe}
                        multiple={false}
                        accept=".pdf,.zip,.rar,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"   
                        onDrop={this.onDrop.bind(this)}
                    >{acaoButton.text}</Dropzone>
                    : <a href={void (0)}
                        onClick={acaoButton.funcao}
                        className={acaoButton.classe}>
                        {acaoButton.text}
                    </a>
                }
            </div>
        );
    }
}
function mapStateToProps(state){

    return {session: state.auth.session,menu: state.configReducer.menu}

}

export default connect(mapStateToProps,{SetRespondeTarefasUploadFiles,GetTarefasAluno,SetError})(missao_acao);




// WEBPACK FOOTER //
// ./src/components/aluno/missao/missao_acao.js